import { Typography } from '@material-ui/core';

function Faq() {
  return <Typography>This is the FAQ Page</Typography>;
}
export default Faq;
